/* eslint-disable no-unused-vars */
// eslint-disable-next-line max-len
import { ReactComponent as AcctIcon } from "../assests/images/SVG/accountBkIcon.svg";
import { ReactComponent as CashIcon } from "../assests/images/SVG/cashBooking.svg";
import { ReactComponent as DrcIcon } from "../assests/images/SVG/drsScanIcon.svg";
import { ReactComponent as HomeIcon } from "../assests/images/SVG/Home.svg";
import { ReactComponent as ViewIcon } from "../assests/images/SVG/viewMsg.svg";
import { ReactComponent as SidebarSetting } from "../assests/images/SVG/sidebar-setting.svg";

import { ReactComponent as HomeIconFilled } from "../assests/images/SVG/home-filled.svg";
import { ReactComponent as CashIconFilled } from "../assests/images/SVG/cash-booking-filled.svg";
import { ReactComponent as ViewIconFilled } from "../assests/images/SVG/viewMsgFilled.svg";
import { ReactComponent as SidebarSettingFilled } from "../assests/images/SVG/sidebar-setting-filled.svg";
import constants from "../constants/constants";

const { ROLES } = constants;
const { CP_ADMIN, HO_ADMIN } = ROLES;

export const sideMenuList = [
  {
    active: "1",
    icon: HomeIcon,
    fillIcon: HomeIconFilled,
    title: "Home",
    id: "home",
    route: "/dashboard",
    role: "",
  },
  {
    active: "2",
    icon: CashIcon,
    fillIcon: CashIconFilled,
    title: "Cash Booking",
    id: "cash-booking",
    route: "/cash-booking",
    role: [CP_ADMIN],
  },
  {
    active: "3",
    icon: AcctIcon,
    fillIcon: AcctIcon,
    title: "Account Booking",
    id: "account-booking",
    route: "/account",
    role: [CP_ADMIN],
  },
  {
    active: "4",
    icon: DrcIcon,
    fillIcon: DrcIcon,
    title: "DRS Scanning",
    id: "drs-scanning",
    route: "",
    role: [CP_ADMIN],
  },
  {
    active: "5",
    icon: SidebarSetting,
    fillIcon: SidebarSettingFilled,
    title: "Settings",
    id: "settings",
    route: "/masters",
    role: [HO_ADMIN],
  },
  {
    active: "6",
    icon: ViewIcon,
    fillIcon: ViewIconFilled,
    title: "View Booking",
    id: "view-booking",
    route: "/viewBooking",
    role: [CP_ADMIN],
  },
];
